<template lang="pug">

  v-dialog(v-model="dialog" width="100%" max-width="530px")

    .dialogHeader

      .dialogHeaderTitle
        | Convidar usuários

      .dialogHeaderClose
        .dialogCloseButton.mdi.mdi-close(@click="close()")

    .dialogBody

      .dialogBodyContent

        .detalhes
          template(v-if="sugerido.length === 0")
            | Você pode definir uma senha para os usuários que ainda não tem conta no SOS Plantão:
          template(v-else)
            | Você pode definir uma senha para os usuários que ainda não tem conta no SOS Plantão. Sugerimos a senha abaixo, mas você pode alterar:

        .dutyDetails

          .dutyDetail
            span.dutyDetailName
              v-icon(size="22" class="searchFieldIcon") mdi-lock
            span.dutyDetailValue
              input(v-model="defaultPassword" maxlength="64").userField

        .nota
          span Importante
          | : Compartilhe essa senha com sua equipe. Informe que a senha é provisória e eles podem muda-la no aplicativo.

        .dutyDetailButton

          sos-button(
            @buttonClick="close()"
            size="medium"
            buttonIcon="mdi-close"
            buttonIconSize="16"
            color="red"
            buttonLabel="Voltar"
          ).mr-2

          sos-button(
            @buttonClick="close(false)"
            size="medium"
            buttonIcon="mdi-check"
            buttonIconSize="16"
            color="blue"
            buttonLabel="Convidar"
          )

</template>

<script>

  import SosButton from '@/components/SosButton'

  export default {
    name: 'ModalNewUsersDefaultPassword',

    components: {
      'sos-button': SosButton,
    },

    data () {
      return {
        dialog: false,

        sugerido: '',
        defaultPassword: '',
      }
    },

    watch: {
      dialog: {
        // the callback will be called immediately after the start of the observation
        immediate: true,
        handler (newDialog, oldDialog)
        {
          if (!newDialog) {
            this.sugerido = ''
            this.defaultPassword = ''
          }
        },
      },
    },

    methods: {
      open (defaultPassword = '') {
        this.dialog = true
        this.sugerido = defaultPassword
        this.defaultPassword = defaultPassword // Nota: O nome do grupo (tratado) pode ser parametrizado como sugestão.
      },

      close (cancel = true) {
        this.$emit('close', !!cancel === true ? false : this.defaultPassword)
        this.dialog = false
      },
    },
  }

</script>

<style lang="scss" scoped>

  .detalhes {
    margin-top: 0;
    margin-bottom: 15px;

    font-size: 18px;
    font-weight: 500;
    line-height: 25px;
  }

  .dutyDetails {
    border: 1px solid rgba(0, 0, 0, 0.3);
    box-shadow: inset 2px 2px 0px 0px rgba(0, 0, 0, 0.1);

    font-size: 0;
  }

  .userField {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    height: 30px;
    outline: 0;
    border: 0;

    color: steelblue;
    // color: #656565;
    font-size: 16px;
    line-height: 30px;

    &::placeholder {
      color: rgba(70, 130, 180, 0.7);
      // color: #656565;
    }

    &--userName {
      padding-left: 40px;
      padding-right: 10px;
    }
  }

  .userFieldBankAccount {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    height: 70px;
    padding-right: 10px;
    outline: 0;
    border: 0;

    color: steelblue;
    // color: #656565;
    font-size: 16px;
    min-height: 70px;
    line-height: 30px;
    max-height: 150px;

    &::placeholder {
      color: rgba(70, 130, 180, 0.7);
      // color: #656565;
    }
  }

  .dutyDetail {
    padding: 5px 5px 5px 10px;
    // border-top: 1px solid rgba(0, 0, 0, 0.1);
    // box-shadow: inset 2px 2px 0px 0px rgba(0, 0, 0, 0.1);
    font-size: 16px;
    line-height: 30px;
  }

  .dutyDetailButton {
    margin-top: 20px;

    text-align: right;
  }

  .dutyDetailName,
  .dutyDetailValue {
    display: inline-block;
    vertical-align: middle;

    &.dutyDetailName--textarea,
    &.dutyDetailValue--textarea {
      vertical-align: top;
    }
  }

  .dutyDetailName {
    width: 10%;
    padding-right: 10px;

    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
  }

  .dutyDetailValue {
    position: relative;
    width: 90%;
    padding-left: 15px;
    border-left: 1px solid rgba(0, 0, 0, 0.3);

    &.dutyDetailValue--conta {
      min-height: 70px;
    }
  }

  .dutyDetailText {
    display: inline-block;

    color: #656565;
    font-size: 16px;
    line-height: 30px;
  }

  .dutyDetailTextarea {
    display: inline-block;
    vertical-align: top;
    padding-right: 10px;

    color: #656565;
    font-size: 16px;
    line-height: 30px;
  }

  .editUserUserImage,
  .editUserUserName {
    display: inline-block;
    vertical-align: top;
  }

  .editUserUserImage {
    position: absolute;
    left: 15px;
    bottom: 0;
    top: 0;

    width: 30px;
    margin: auto 0;
    border-radius: 100%;
  }

  .editUserUserName {
    width: 100%;
    padding-left: 40px;
    padding-right: 10px;

    color: #656565;
    font-size: 16px;

    // Reticências
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  @media (max-width: 600px)
  {
    .dutyDetailName,
    .dutyDetailValue {
      vertical-align: top;
    }

    .editUserUserImage {
      left: 0;
    }

    .dutyDetailName {
      width: 100%;
    }

    .dutyDetailValue {
      width: 100%;
      padding-left: 0;
      border-left: 0;
    }
  }

</style>
